import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {formatMoney} from "../../../utilities/common";
import React from "react";
import {Badge} from "react-bootstrap";
import {Check, X} from "react-bootstrap-icons";
import {BsCashStack} from "react-icons/bs";
import {TbFlagQuestion} from "react-icons/tb";
import {BiLogoVenmo} from "react-icons/bi";
import {SiCashapp, SiPaypal} from "react-icons/si";
import { useHouseDispatch } from "../../../contexts/HouseContext";

export function UnsettledTransactionDetail({ gameId, playerId, transaction, setErrorMessage }) {
    const actions = useHouseDispatch();

    let buyIn = '';

    buyIn = transaction.amount.toFixed(2)

    const toggleTransactionStatus = async () => {
        const result = await actions.updateCoverTransactions(gameId, playerId, transaction)
        if (result.error) {
            setErrorMessage(result.error);
        }
    }

    return (
        <Row className="unsettled-transactions">
            <Col xs={10}><TransactionStatus transaction={transaction} onStatusToggle={toggleTransactionStatus}/></Col>
            <Col xs={2} className="money">{formatMoney(buyIn)}</Col>
        </Row>
    );
}

function TransactionStatus({transaction, onStatusToggle}) {
    let transactionType;
    let paymentType;

    switch (transaction.type) {
        case 'BUY_IN':
            transactionType = 'Buy-In';
            break;
        case 'CASH_OUT':
            transactionType = 'Cash-Out';
            break;
        default:
            transactionType = 'Unknown';
    }

    switch (transaction.paymentType) {
        case 'CASH':
            paymentType = <BsCashStack title={"Cash"} />
            break;
        case 'CASH_APP':
            paymentType = <SiCashapp title={"CashApp"} />
            break;
        case 'PAYPAL':
            paymentType = <SiPaypal title={"PayPal"} />
            break;
        case 'VENMO':
            paymentType = <BiLogoVenmo title={"Venmo"} />
            break;
        default:
            paymentType = <TbFlagQuestion title={"Unknown"} />
    }

    return (
        <div className="transaction-status">
            <Col>{transactionType}</Col>
            <Col><span className={'payment-type'}>{paymentType}</span></Col>
            <Col onClick={onStatusToggle}>
                <Badge bg={transaction.isSettled ? "success" : "warning"}>
                    {transaction.isSettled ? <Check/> : <X/>}
                </Badge>
            </Col>
        </div>
    );
}
